import { NumberField, NumberFieldProps } from './number-field';
import { FieldValues, Path } from 'react-hook-form';

export interface LabourHoursFieldProps<T extends FieldValues = FieldValues> extends Omit<NumberFieldProps<T>, 'name'> {
  name?: Path<T>;
}

export const LabourHoursField = <T extends FieldValues = FieldValues>({
  name = 'labHour' as Path<T>,
  ...rest
}: LabourHoursFieldProps<T>) => {
  return <NumberField name={name} {...rest} isSmallSize allowNegative={false} />;
};
